import DynamicTargetFilter from "./DynamicTargetFilter";

export default DynamicTargetFilter;
